import axios from 'axios';

// Reports whether a school's yearbooks are still orderable to the school
// (:active), only via ship-to-home (:home), or closed. See
// Api::YearbookHomeDeliveryController / YearbookHomeDelivery::Resolver.
// Path is relative: axios baseURL is already '/api/v1' (cf. api/orders.js).
export const fetchYearbookHomeDelivery = (schoolId) => axios.get('/yearbook_home_delivery', {
  params: { school_id: schoolId },
});
